var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "follow-us", class: _vm.followUsClasses },
    [
      _c("icon", {
        staticClass: "follow-us__squiggle-left",
        attrs: {
          name: "follow-us-squiggle-left",
          width: _vm.isMobile ? "150px" : "348px",
          height: _vm.isMobile ? "300px" : "451px"
        }
      }),
      _c("icon", {
        staticClass: "follow-us__squiggle-right",
        attrs: {
          name: "follow-us-squiggle-right",
          width: _vm.isMobile ? "30px" : "82px",
          height: _vm.isMobile ? "275px" : "657px"
        }
      }),
      _c("h2", { staticClass: "follow-us__headline" }, [
        _vm._v(_vm._s(_vm.headline))
      ]),
      _c(
        "a",
        { staticClass: "follow-us__link", attrs: { href: _vm.socialLinkUrl } },
        [_vm._v(_vm._s(_vm.socialLinkText))]
      ),
      _vm.useInstafeedApp
        ? _c("div", {
            staticClass: "follow-us__instafeed",
            attrs: { id: "insta-feed" }
          })
        : _c(
            "carousel",
            {
              staticClass: "carousel--follow-us",
              attrs: {
                "slides-to-show": _vm.isMobile ? 1.3 : 5,
                "center-mode": _vm.isMobile,
                dots: _vm.isMobile
              }
            },
            _vm._l(_vm.socialImages, function(image, index) {
              return _c(
                "slide",
                {
                  key: image.src + "__" + index,
                  staticClass: "slide--follow-us"
                },
                [
                  _c("responsive-image", {
                    attrs: { src: image.src, alt: image.alt, draggable: false }
                  })
                ],
                1
              )
            }),
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }